import { useNavigate, useParams } from "react-router-dom";
import i18n from "./i18n";

const LanguageSwitcher = () => {
  const navigate = useNavigate();
  const { lang = "ka" } = useParams();

  const changeLanguage = (newLang) => {
    i18n.changeLanguage(newLang);
    const currentPath = window.location.pathname;
    const newPath = currentPath.replace(`/${lang}`, `/${newLang}`);
    navigate(newPath);
  };

  return (
    <select
      className="language-switcher"
      value={lang}
      onChange={(e) => changeLanguage(e.target.value)}
    >
      <option value="ka">Georgian</option>
      <option value="en">English</option>
      <option value="ru">Russian</option>
      <option value="tr">Turkish</option>
    </select>
  );
};

export default LanguageSwitcher;
